let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5tBtR")).then(() => parcelRequire('4PDxh'));